const features = [
  { icon: 'ri-map-pin-line', label: '8 Sessões Presenciais' },
  { icon: 'ri-video-chat-line', label: '8 Sessões Online' },
  { icon: 'ri-focus-3-line', label: 'Aplicação direta no negócio' },
  { icon: 'ri-map-pin-2-line', label: 'Manaus / AM' },
  { icon: 'ri-shield-check-line', label: '6 Módulos + 1 Bônus' },
];

export default function ProgramaSection() {
  const scrollToForm = () => {
    document.getElementById('proximos-passos')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="programa" className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left */}
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
              O programa
            </p>
            <h2 className="text-5xl md:text-7xl font-black text-gray-900 leading-[1.0] mb-6">
              TRANSFOR-<br />MAÇÃO<br />
              <span className="text-amber-500">REAL 60D</span>
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-10 max-w-md">
              Um programa intensivo completo para te ajudar a estruturar e organizar o seu negócio em 60 dias. Personalizado de acordo com o seu negócio com aplicação na prática, acompanhamento e suporte.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {features.map((f) => (
                <div key={f.label} className="flex items-center gap-3 bg-white rounded-xl px-5 py-4 border border-stone-100">
                  <div className="w-9 h-9 flex items-center justify-center bg-amber-50 rounded-lg shrink-0">
                    <i className={`${f.icon} text-amber-600 text-base`} />
                  </div>
                  <span className="text-gray-800 text-sm font-semibold">{f.label}</span>
                </div>
              ))}
            </div>

            <button
              onClick={scrollToForm}
              className="whitespace-nowrap inline-flex items-center gap-3 bg-gray-900 hover:bg-gray-700 text-white font-bold text-sm px-8 py-4 rounded-full transition-all cursor-pointer"
            >
              GARANTIR MINHA VAGA
              <span className="w-7 h-7 flex items-center justify-center bg-amber-400 rounded-full">
                <i className="ri-arrow-right-line text-gray-900 text-sm" />
              </span>
            </button>
          </div>

          {/* Right */}
          <div className="relative mt-8 lg:mt-0">
            <div className="rounded-3xl overflow-hidden w-full h-[320px] sm:h-[420px] md:h-[500px] lg:h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=Brazilian%20entrepreneur%20in%20business%20consulting%20session%20Manaus%20Amazon%2C%20professional%20man%20working%20at%20desk%20with%20documents%20charts%20and%20laptop%2C%20modern%20office%20environment%2C%20warm%20natural%20lighting%2C%20focused%20and%20determined%20expression%2C%20clean%20minimal%20background%2C%20high%20quality%20photography&width=700&height=600&seq=prog001&orientation=portrait"
                alt="Sessão presencial do programa"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Floating card — reposicionado pra não sair da tela no mobile */}
            <div className="absolute bottom-4 left-4 md:-bottom-6 md:-left-6 bg-white rounded-2xl p-4 md:p-6 border border-stone-100 max-w-[180px] md:max-w-[220px]">
              <div className="text-3xl md:text-4xl font-black text-amber-500 mb-1">70%</div>
              <div className="text-gray-900 font-bold text-xs md:text-sm mb-1">Aplicação Prática</div>
              <div className="text-gray-400 text-xs leading-relaxed hidden md:block">Você sai de cada sessão com ações implementadas</div>
            </div>

            {/* Floating badge — reposicionado */}
            <div className="absolute top-4 right-4 md:-top-4 md:-right-4 bg-gray-900 text-white rounded-2xl px-4 py-2 md:px-5 md:py-3 text-center">
              <div className="text-xl md:text-2xl font-black text-amber-400">60</div>
              <div className="text-xs text-white/60 font-medium">dias</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
